import { render, staticRenderFns } from "./TriggerView.vue?vue&type=template&id=dc56369c&scoped=true&"
import script from "./TriggerView.vue?vue&type=script&lang=js&"
export * from "./TriggerView.vue?vue&type=script&lang=js&"
import style0 from "./TriggerView.vue?vue&type=style&index=0&id=dc56369c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc56369c",
  null
  
)

export default component.exports